<script lang="ts">
import type { InjectionKey } from 'vue'

import type { FormItemContext } from '@fondof-ui/components/form/types'
import type { HTMLAttributeClass } from '@fondof-ui/types'

export const FORM_ITEM_INJECTION_KEY = Symbol() as InjectionKey<string>
</script>

<script lang="ts" setup>
// eslint-disable-next-line no-duplicate-imports
import { provide, ref } from 'vue'
import { useId } from 'radix-vue'

const props = defineProps<HTMLAttributeClass>()

const id = useId()
const warning = ref<string | undefined>()
const success = ref<string | undefined>()

provide<FormItemContext>(FORM_ITEM_INJECTION_KEY, {
  id,
  warning,
  success,
  updateWarning: (newWarning?: string) => {
    warning.value = newWarning
  },
  updateSuccess: (newSuccess?: string) => {
    success.value = newSuccess
  },
})
</script>

<template>
  <div :class="props.class">
    <slot />
  </div>
</template>
